import { QueryClient, QueryKey } from '@tanstack/react-query';
import { isEmptyObject } from './objectHelpers';

export const filterQueryKey = (queryKey: QueryKey) => {
  return queryKey.filter((key) => {
    if (key === undefined || key === null) {
      return false;
    }
    if (isEmptyObject(key)) {
      return false;
    }
    if (Array.isArray(key) && key.length === 0) {
      return false;
    }
    return true;
  });
};

// If an inactive infinite query is invalidated while inactive, it doesn't automatically refetch when it becomes active again.
// To address this, we remove data from inactive queries to force a refetch when they become active.
// For active queries, we simply invalidate them as usual to trigger a refetch.
export const invalidateQueries = (queryClient: QueryClient, queryKey: QueryKey) => {
  queryClient.removeQueries({
    queryKey: filterQueryKey(queryKey),
    type: 'inactive',
  });

  queryClient
    .invalidateQueries({
      queryKey: filterQueryKey(queryKey),
      type: 'active',
    })
    .catch(() => {});
};
